// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".date_picker_modal>.form-control{width:100%;margin-top:10px;margin-bottom:10px}\n", ""]);
// Exports
module.exports = exports;
